import { http } from '@/core/api/';
import schoolTypes from '@/utils/constants/student/schoolTypes';
import locationApi from '@/modules/common/location.api';
import {
  schoolRecommendationModelToDto,
  schoolAlternativeDtoToModel,
} from './_utils';

export const schoolRecommendationApi = {
  /**
   *
   * @param {{ academicYearId: number, schoolId: number }} param0
   * @returns SchoolAlternativeDto[]
   */
  async searchAlternatives({ academicYearId, schoolId, requestId }) {
    try {
      const { data } = await http.get(
        `api/tapRequests/schoolAlternativeLocation/${schoolId}/${academicYearId}/${requestId}`
      );
      return data?.map(schoolAlternativeDtoToModel) ?? [];
    } catch {
      return [];
    }
  },

  /**
   *
   * @param {{ tapRequestId: number | string, model: SchoolRecommendationModel }} param0: { model: SchoolRecommendationModel }
   * @returns SchoolRecommendationReturnDto
   */
  async create({ tapRequestId, tapRequestTypeId, model }) {
    try {
      const payload = schoolRecommendationModelToDto({
        ...model,
        tapRequestTypeId,
      });
      const { data } = await http.post(
        `/api/tapRequests/${tapRequestId}/tapRecomendationSchool`,
        payload
      );
      return data ?? null;
    } catch {
      return null;
    }
  },

  /**
   *
   * @param {{ tapRequestId: number | string, id: number, model: SchoolRecommendationModel }} param0: { model: SchoolRecommendationModel }
   * @returns SchoolRecommendationReturnDto
   */
  async edit({ tapRequestId, tapRequestTypeId, id, model }) {
    try {
      const payload = schoolRecommendationModelToDto({
        ...model,
        tapRequestTypeId,
      });
      const { data } = await http.put(
        `/api/tapRequests/${tapRequestId}/tapRecomendationSchool/${id}`,
        payload
      );
      return data ?? null;
    } catch {
      return null;
    }
  },

  /**
   *
   * @param {{ id: number}} param0
   */
  async remove({ id, tapRequestTypeId }) {
    try {
      await http.delete(
        `/api/tapRequests/tapRecomendationSchool/${id}/typeId/${tapRequestTypeId}`
      );
      return true;
    } catch {
      return null;
    }
  },
};

export const schoolRecommendationCatalogApi = {
  async getRegions({ academicYearId }) {
    return await locationApi.getRegions({
      academicYearId,
      schoolTypes: schoolTypes.PublicSchool,
    });
  },

  async getMunicipalities({ academicYearId, regionId }) {
    return await locationApi.getMunicipalities({
      academicYearId,
      regionId,
      schoolTypes: schoolTypes.PublicSchool,
    });
  },

  async getSchools({ academicYearId, regionId, municipalityId }) {
    return await locationApi.getSchools({
      academicYearId,
      regionId,
      municipalityId,
      schoolTypes: schoolTypes.PublicSchool,
    });
  },
};
